import { Order } from '@services';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useGenerateInvoiceOrders = (ids: string[]): Order[] => {
  const { orderStore } = useStore();
  const { generateInvoiceOrders } = orderStore;

  useEffect(() => {
    ids && ids.length && orderStore.getGenerateInvoiceOrders(ids);
  }, [orderStore, ids]);

  return Array.from(generateInvoiceOrders.values());
};
